module.exports = __webpack_public_path__ + "static/media/devop.bbc04c24.png";